import { render, staticRenderFns } from "./AdminDataTable.vue?vue&type=template&id=c5db9dc0&scoped=true"
import script from "./AdminDataTable.vue?vue&type=script&lang=js"
export * from "./AdminDataTable.vue?vue&type=script&lang=js"
import style0 from "./AdminDataTable.vue?vue&type=style&index=0&id=c5db9dc0&prod&lang=css"
import style1 from "./AdminDataTable.vue?vue&type=style&index=1&id=c5db9dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5db9dc0",
  null
  
)

export default component.exports